import 'dayjs/locale/ja'

const ja = {
  calendar: {
    sameDay: '[今日] LT',
    nextDay: '[明日] LT',
    nextWeek: '[来週]dddd LT',
    lastDay: '[昨日] LT',
    lastWeek: '[先週]dddd LT',
    sameElse: 'L'
  }
}

export default ja
